import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { RootStore } from 'store/types';
import { Grid, GridItem } from 'ui-toolkit';
import { CoverWrapper } from 'ui-toolkit/components/Cover/CoverWrapper';
import AssociateOrderWithIdModal from './OrderAssociation/AssociateOrderWithIdModal';
import DisassociateOrderWithId from './OrderAssociation/DisassociateOrderWithId';
import { CancellationRequestMessage } from './OrderCancel/CancellationRequestMessage';
import { OrderProgressContainer } from './OrderProgress/OrderProgressContainer';
import { SummaryContainer } from './Summary/SummaryContainer';
import { getUserName } from 'utilities/users/getUserName';
import { OrderAttributesContainer } from './Attributes/OrderAttributesContainer';
import { getUsers } from '../../../store/usersCollection/allUsers/dispatch';
import { convertEUserTypeToTUsertype, IGetUser } from '../../../types/users/IUser';
import { useAppDispatch } from '../../../store/store';
import { TasksContainer } from 'components/tasks/TasksContainer';
import { eInternalOrderStatus } from '../../../ui-toolkit/enums/eInternalOrderStatus';
import { eCancellationRequestStatus } from '../../../ui-toolkit/orders/interfaces/eCancellationRequestStatus';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';

export const OrderOverviewContainer: React.FC = () => {
  const { data: order } = useSelectCurrentOrder();
  const dispatch = useAppDispatch();

  const [, setShowUpdateCancellationRequestDialog] = useState(false);
  const isCancelled = order.orderInformation.status === eInternalOrderStatus.cancelled;
  const cancellationRequest = order.latestCancellationRequest;
  useEffect(() => {
    if (
      cancellationRequest?.status === eCancellationRequestStatus.Completed &&
      cancellationRequest?.resolverUserId &&
      cancellationRequest?.resolverUserType
    ) {
      const cancelledUser: IGetUser[] = [
        {
          userId: cancellationRequest?.resolverUserId,
          userType: convertEUserTypeToTUsertype(cancellationRequest?.resolverUserType),
        },
      ];
      dispatch(getUsers(cancelledUser));
    }
  }, [cancellationRequest, dispatch]);
  const { users } = useSelector((state: RootStore) => state.usersCollection.allUsers);
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const resolver =
    cancellationRequest?.requesterUserType && cancellationRequest?.resolverUserId
      ? getUserName(users, isZillowClosingEnabled, cancellationRequest.resolverUserType, cancellationRequest.resolverUserId)
      : undefined;

  return (
    <>
      <DisassociateOrderWithId />
      <AssociateOrderWithIdModal />
      <Grid>
        {cancellationRequest && (
          <GridItem>
            <CancellationRequestMessage
              requestCreatedBy={cancellationRequest.requesterUserType}
              status={cancellationRequest.status}
              onClick={() => setShowUpdateCancellationRequestDialog(true)}
              message={cancellationRequest.cancellationReason}
              updatedAt={cancellationRequest.updatedAt}
              isCancelled={isCancelled}
              resolver={resolver}
            />
          </GridItem>
        )}
        <Grid columnCount={2} templateColumns={`1fr 3fr`}>
          <SummaryContainer />
          <Grid>
            <OrderProgressContainer />
            <OrderAttributesContainer orderOpenDate={order.orderInformation.created} />
            <CoverWrapper showCover={isCancelled} clickThrough={true}>
              <TasksContainer defaultTab={'All'} showFiltersByDefault />
            </CoverWrapper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
